export default __webpack_public_path__ + "static/media/qrcode.080d7bfd.png";